import { createContext } from 'react';
import initialTenantFeedState from './initialTenantFeedState';

const BrandFeedContext = createContext(initialTenantFeedState);

export default BrandFeedContext;
